import React, { useContext, useEffect } from 'react'
import './BlockedJourneyNew.css'
import { crossBtnIcon } from '../../../images/btnIcons'
import LanguageTranslater from '../../HOC/LanguageTranslater'
import crossmarkAnimationJson from '../../../images/new_ui_imgs/crossmark.json';
import lottie from 'lottie-web';
import { SpeakerContext } from '../../../context/SpeakerContext';
import { Button } from 'unified-ui-components-library';

function BlockedJourneyNew({ translate, handleClick, businessMsgVerify, submissionRestrictedVerify, businessMsgGenerate, submissionRestrictedGenerate }) {
    const ln = localStorage.getItem("LanguageSelected")
    const channelName = localStorage.getItem("channelName")
    const msgType = channelName == 'by' ? 'ybl_blocked_journey' : 'incorrect_res_msg'
    const { handleAudioIconDisplay } = useContext(SpeakerContext)

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    
    const expiredMsg = sessionStorage.getItem("expiredBusinessMsg");

    const isRedirectedFromSD = params.s === 'sd'

    useEffect(() => {
        handleAudioIconDisplay(false)
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function (event) {
            window.history.go(1);
        };

        const instance = lottie.loadAnimation({
            container: document.querySelector("#blocked-journey-animation-div"),
            animationData: crossmarkAnimationJson,
            // loop: false
        })

        return () => {
            instance.destroy()
        }

    }, [])
    return (
        <div className='blocked_jrny-otp-cntnr'>
            <div className={`blocked_jrny_content_cntnr ${params.s === 'pc' ? "max-width-pc" : ""}`} >
                <div className='blocked_jrny-otp-img'>
                    {/* <img src={crossBtnIcon} alt="crossmark" /> */}
                    <div id='blocked-journey-animation-div' ></div>
                </div>
                {params.s === 'pi' ? (
    <>
        <div className='blocked_jrny-otp-head-txt'>
            <p className={ln === "Manipuri" ? "manipuri-font" : ""}>
                Policy Verification was unsuccessful
            </p>
        </div>
        <div className='blocked_jrny-otp-para-txt'>
            <p className={ln === "Manipuri" ? "manipuri-font" : ""}>
                {expiredMsg}
            </p>
        </div>
    </>
                ) : (
                <>
                <div className='blocked_jrny-otp-head-txt'>
                    {
                       isRedirectedFromSD ? null :  params.s === 'pc' ? <p>Policy verification was unsuccessful</p> : <p className={ln == "Manipuri" ? "manipuri-font" : ""}>
                       {submissionRestrictedVerify ? <>Policy verification was unsuccessful </> : submissionRestrictedGenerate ? <>{translate("verification_unsuccessful")}</> : <>{translate("incorrect_answers")}</>}
                   </p>
                    }
                </div>
                <div className='blocked_jrny-otp-para-txt'>
                    {
                        params.s === 'pc' || isRedirectedFromSD ? <p>You can close this page and re-initiate the journey with link sent on your email.</p> : <p className={ln == "Manipuri" ? "manipuri-font" : ""}>
                            {submissionRestrictedVerify ? <>{businessMsgVerify}</> : submissionRestrictedGenerate ? <>{translate(businessMsgGenerate)}</> : <>{translate("close_page_connec_seller")}</>}

                        </p>
                    }
                </div>
                </>
                )}
            </div>
            <div className='blocked_jrny-otp-button'>
                {
                    submissionRestrictedVerify || submissionRestrictedGenerate || params.s === 'pi' || isRedirectedFromSD ?
                        <Button
                            className={ln == "Manipuri" ? "manipuri-font" : ""}
                            buttonType="secondary"
                            width="264"
                        >
                            {translate("Close this page")}
                        </Button>
                        :
                        <Button
                            className={ln == "Manipuri" ? "manipuri-font" : ""}
                            onClick={handleClick}
                            buttonType="secondary"
                            width="264"
                        >
                            {translate("Close this page")}
                        </Button>
                }
            </div>
        </div>
    )
}

export default LanguageTranslater(BlockedJourneyNew)